import {Component, OnInit} from '@angular/core';
import {TiendaServices} from '../../CoreModule/services/tienda.services';
import {InventarioServices} from '../services/inventario.services';
import {NgxSpinnerService} from 'ngx-spinner';
import {TiendaEntity} from '../../CoreModule/entities/tienda.entity';
import {TypeaheadMatch} from 'ngx-bootstrap';
import * as moment from 'moment';

@Component({
  selector:"reporte-proddesc-preciovent",
  templateUrl:"../templates/reporte.proddesc.precioventa.template.html"
})
export class ReporteProddescPrecioventaComponent implements OnInit{

  public tiendas: TiendaEntity[] = [];
  public tiendaSelect: TiendaEntity;
  public tSelectName: string = '';
  public tituloReport: string = '';

  public resultCat: any[] = [];

  graphPrecio:any[] = [];
  graphCantidad:any[] = [];

  constructor(private ts: TiendaServices, private is: InventarioServices, private spinner: NgxSpinnerService) {
  }

  ngOnInit(): void {
    this.spinner.show();

    this.ts.getAllTiendas().subscribe(d => {
      console.log(d);
      this.tiendas = d.data.tiendas;
      this.spinner.hide();
      this.tiendaSelect = this.tiendas[0];
      this.tSelectName = this.tiendaSelect.nombre;
    });

    this.is.obsSendProdDescXPrecio.subscribe(d=>{
      this.spinner.hide();

      let jData = JSON.parse(d);

      let prodDesc = jData.prodDesc;

      for(let p of prodDesc){
        let cFound = this.resultCat.find(rc=> rc.nombre == p.negocio.trim());

        if(cFound){
          cFound.productos.push(p);
          cFound.precio += (p.precio * p.cantidades);
          cFound.cantidad += p.cantidades;
        }
        else{
          let c = {
            nombre: p.negocio.trim(),
            productos:[],
            precio: (p.precio * p.cantidades),
            cantidad: p.cantidades
          };

          c.productos.push(p);

          this.resultCat.push(c);
        }
      }

      this.organizarCategoriasyMarcas();
      console.log(this.resultCat);

      for(let c of this.resultCat){
        this.graphPrecio.push({
          name:c.nombre,
          value:c.precio
        });

        this.graphCantidad.push(({
          name:c.nombre,
          value: c.cantidad
        }));

      }

    });
  }

  currencyFormatting(value: number) {
    return `\$${Math.round(value).toLocaleString()}`;
  }

  organizarCategoriasyMarcas(){
    for(let c of this.resultCat){
      c.productos.sort((a,b)=>{
        if(a.precio * a.cantidades > b.precio * b.cantidades)
          return -1;
        else
          return 1;
      });

      c.productos = c.productos.slice(0,5);
    }
  }

  tiendaSeleccionada(event: TypeaheadMatch) {
    this.tiendaSelect = event.item;
  }

  consultarDatos() {
    if (this.tiendaSelect) {
      this.resultCat = [];
      this.graphPrecio = [];
      this.graphCantidad = [];
      this.tituloReport = `Top 5 por Categoría Productos descontinuados por Precio Venta Publico`;

      this.is.getProdDescXPrecio(4, this.tiendaSelect.id.toString());
      this.spinner.show();

    }
  }
}
